/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ChosenDescription } from './';
import {
    ChosenDescriptionFromJSON,
    ChosenDescriptionFromJSONTyped,
    ChosenDescriptionToJSON,
} from './';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChosenProjectDescriptionField
 */
export interface ChosenProjectDescriptionField extends UpdatedField {
    /**
     * 
     * @type {ChosenDescription}
     * @memberof ChosenProjectDescriptionField
     */
    value: ChosenDescription;
}

/**
 * Check if a given object implements the ChosenProjectDescriptionField interface.
 */
export function instanceOfChosenProjectDescriptionField(value: object): value is ChosenProjectDescriptionField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ChosenProjectDescriptionFieldFromJSON(json: any): ChosenProjectDescriptionField {
    return ChosenProjectDescriptionFieldFromJSONTyped(json, false);
}

export function ChosenProjectDescriptionFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChosenProjectDescriptionField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': ChosenDescriptionFromJSON(json['value']),
    };
}

export function ChosenProjectDescriptionFieldToJSON(value?: ChosenProjectDescriptionField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': ChosenDescriptionToJSON(value['value']),
    };
}

